<script setup lang="ts">
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  logo: null,
  logoAlt: null,
  label: null,
  disabled: { type: Boolean },
  loading: { type: Boolean }
});
import type { LoginData } from '~/types';

const emit = defineEmits(["login", "reset-passwort", "register", "update:logo", "update:logoAlt", "update:label", "update:disabled", "update:loading"])

__MACROS_useVModel("logo", "logoAlt", "label", "disabled", "loading")

defineOptions({
  name: 'LoginComponent',
})

const loading = ref(false)
const nutzer = reactive({
  nutzername: '',
  passwort: '',
})

const rules = {
  nutzername: { required: requiredWith('Bitte geben Sie einen Nutzernamen an.') },
  passwort: { required: requiredWith('Bitte geben Sie das Passwort an.') },
}
const v$ = useVuelidate(rules, nutzer as any, { $autoDirty: true })

async function login() {
  const isFormCorrect = await v$.value.$validate()

  if (!v$.value.$error && isFormCorrect)
    emit('login', { nutzername: nutzer.nutzername, passwort: nutzer.passwort })
}

/*
// TODO Prio Niedrig
function passwortVergessen() {
  emit('login', { nutzername: nutzer.nutzername, passwort: nutzer.passwort })
// router.push({ path: '/passwort-vergessen' })
// modal.handleInfo('Diese Funktion steht aktuell noch nicht zur Verfügung.')
}

// TODO Prio Niedrig
function registrieren() {
  emit('login', { nutzername: nutzer.nutzername, passwort: nutzer.passwort })
// router.push({ path: '/registrieren' })
// modal.handleInfo('Diese Funktion steht aktuell noch nicht zur Verfügung.')
}
*/
</script>

<template>
  <main text="center dark:gray-200">
    <div class="login-bg pt:mt-0 mx-auto flex flex-col items-center justify-center px-6 pt-8 md:h-screen dark:bg-gray-900">
      <!-- Card -->
      <div class="max-w-xl w-full rounded-lg bg-white p-6 shadow space-y-8 dark:bg-gray-800 sm:p-8">
        <a href="/" class="mb-8 flex items-center justify-center text-2xl font-semibold lg:mb-10 dark:text-white">
          <img :src="logo" class="mr-3 h-8 w-8" :alt="logoAlt">
          <span>{{ label }}</span>
        </a>
        <form>
          <TheInput
            id="nutzername"
            v-model="nutzer.nutzername"
            class="p-4"
            type="text"
            label="Nutzername"
            placeholder="Mustermann"
            align="start"
            bind-attrs
            :v$="v$"
            :disabled="loading || disabled"
            @keydown.enter.exact.stop.prevent=""
          />

          <!-- div class="m-0 mb-8 mr-4 mt--6 flex items-start">
            <div class="ml-auto text-sm font-medium text-gray-500 hover:cursor-pointer dark:text-gray-400">
              Nicht registriert? <a class="text-blue-700 dark:text-blue-500 hover:underline" disabled @click.exact.stop.prevent="registrieren">Jetzt Account erstellen</a>
            </div>
          </div -->

          <TheInput
            id="passwort"
            v-model="nutzer.passwort"
            class="mb-0 p-4"
            type="password"
            label="Passwort"
            placeholder="Passwort"
            align="start"
            bind-attrs
            :v$="v$"
            :disabled="loading || disabled"
            @input="(event: any) => nutzer.passwort = event.target.value"
            @keydown.enter.exact.stop.prevent="login"
          />

          <!-- div class="m-0 mb-8 mr-4 mt--6 flex items-start">
            <a class="ml-auto text-sm font-medium text-blue-700 hover:cursor-pointer dark:text-blue-500 hover:underline" disabled @click.exact.stop.prevent="passwortVergessen">
              Passwort vergessen?
            </a>
          </div -->

          <div class="flex items-center justify-around">
            <TheButton
              id="login"
              label="Anmelden"
              class="text-center text-base"
              :disabled="loading || v$.$error || !v$.$anyDirty || disabled"
              :loading="loading"
              @click="login"
            />
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
